// extracted by mini-css-extract-plugin
export var acitonButtons = "_hc-0";
export var additionalIcon = "_hc-f";
export var block = "_hc-1";
export var blockContent = "_hc-7";
export var blockDescription = "_hc-8";
export var blockIcon = "_hc-9";
export var blockTitle = "_hc-6";
export var border = "_hc-a";
export var center = "_hc-l";
export var edge = "_hc-b";
export var edgeLabel = "_hc-c";
export var edgePath = "_hc-d";
export var error = "_hc-e";
export var flowchart = "_hc-g";
export var flowchartContent = "_hc-h";
export var highlighted = "_hc-3";
export var hover = "_hc-4";
export var icon = "_hc-i";
export var left = "_hc-m";
export var navButton = "_hc-j";
export var navButtons = "_hc-k";
export var right = "_hc-n";
export var selected = "_hc-2";
export var small = "_hc-5";